export default __webpack_public_path__ + "static/media/edit.e0238bf8.svg";